<template>
  <div :class="variant">
    <header v-if="header">
      <slot name="header"></slot>
    </header>
    <main>
      <slot></slot>
    </main>
    <footer v-if="footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: false,
})
export class PCard extends Vue {
  @Prop({ required: false, default: "p_card" }) variant!: string;
  @Prop({ required: false, default: false }) header!: boolean;
  @Prop({ required: false, default: false }) footer!: boolean;
}
export default PCard;
</script>
<style scoped>
.p_card {
  background-color: #ffffff;
  border: solid 1px #f9f9f9;
}
.p_card_primary {
  background-color: #ffd102;
  color: #4c4c4c;
}
.p_card_dark {
  background-color: #4c4c4c;
  color: #ffffff;
}
.p_card_gold {
  background-color: #cca701;
  color: #ffffff;
}
.p_card_ligth {
  background-color: #f4f4f4;
  color: #4c4c4c;
}
.p_card,
.p_card_primary,
.p_card_dark,
.p_card_gold,
.p_card_ligth {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.059);
}

.p_card main,
.p_card header,
.p_card_primary main,
.p_card_primary header,
.p_card_dark main,
.p_card_dark header,
.p_card_gold main,
.p_card_gold header,
.p_card_ligth main,
.p_card_ligth header {
  padding: 19px;
}

.p_card header,
.p_card_primary header,
.p_card_dark header,
.p_card_gold header,
.p_card_ligth header {
  display: flex;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  color: #565a57;
  border-bottom: 1px solid rgb(77, 77, 77, 0.1);
}
.p_card header,
.p_card_primary header,
.p_card_ligth header {
  color: #4c4c4c;
}

.p_card_dark header,
.p_card_gold header {
  color: #ffffff;
}
.p_card footer,
.p_card_primary footer,
.p_card_dark footer,
.p_card_gold footer,
.p_card_ligth footer {
  font-size: 0.5rem;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.21;
  letter-spacing: normal;
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
  color: #939393;
  border-top: 1px solid rgb(77, 77, 77, 0.1);
}

.p_card_primary footer,
.p_card_dark footer,
.p_card_gold footer {
  color: #ffffff;
}

.card-deck .p_card,
.card-deck .p_card_primary,
.card-deck .p_card_dark,
.card-deck .p_card_gold,
.card-deck .p_card_ligth {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck .p_card,
  .card-deck .p_card_primary,
  .card-deck .p_card_dark,
  .card-deck .p_card_gold,
  .card-deck .p_card_ligth {
    flex: 1 0 0%;
    margin-right: 15px;
    margin-left: 15px;
  }
}
/** Textos espoecificos de card*/
.p_card_text {
  font-size: 1.3rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.09;
  letter-spacing: normal;
}
.p_card_text_secundary {
  font-size: 0.7rem;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
}
</style>
